import RCTDeviceEventEmitter from 'react-native-web/dist/vendor/react-native/NativeEventEmitter/RCTDeviceEventEmitter';
import RCTEventEmitter from 'react-native-web/dist/vendor/react-native/emitter/EventEmitter';

export { RCTEventEmitter, RCTDeviceEventEmitter };
